module.exports = __webpack_public_path__ + "static/1.2.A. CAIAN RANDARE 4-e7804dd545b9fa41d96b0215539f58af.jpg";